import '../../sass/overlay.sass';
export default function Overlay({
  children
}) {
  return <div className="overlay">
      {children}
    </div>;
}